import React from "react";
import styled from "styled-components";
import TilePerson from "./Cast/tilePerson";
import { TilesPersonSection, SectionTitle } from "./Cast/styled";

const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
`;

const LimitInfo = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.silver}; /* subtelny szary kolor */
  margin-left: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    font-size: 12px;
    margin-left: 8px;
    width: 100%; /* Wymuś nową linię na bardzo małych ekranach */
    margin-top: 4px;
    margin-left: 0;
  }
`;

const HomeWrapper = ({ tilesDetails, isStandardPlan }) => (
  <Wrapper>
    <SectionWrapper>
      <SectionTitle>Standard</SectionTitle>
      <TilesContainer>
        <TilesPersonSection>
        {tilesDetails
            .filter((person) => person.content === "standard" && person.visible === true)
            .map((person) => (
              <TilePerson
                key={`${person.id}_${person.job}`}
                personName={person.name}
                personRole={person.character}
                personId={person.id}
                personProfilePath={person.profile_path}
                isNew={person.isNew}
                isSoon={person.isSoon}
                address={person.address}
                content={person.content}
                isOffice={true}
                $isPremium={false}
              />
            ))}
        </TilesPersonSection>
        <GradientOverlay />
      </TilesContainer>
    </SectionWrapper>

    <SectionWrapper>
        <TitleContainer>
          <SectionTitle isPremium>Premium</SectionTitle>
          {isStandardPlan && (
            <LimitInfo>(Ograniczone użycie dla Standard)</LimitInfo>
          )}
        </TitleContainer>
      <TilesContainer>
        <TilesPersonSection>
        {tilesDetails
            .filter((person) => person.content === "premium" && person.visible === true)
            .map((person) => (
              <TilePerson
                key={`${person.id}_${person.job}`}
                personName={person.name}
                personRole={person.character}
                personId={person.id}
                personProfilePath={person.profile_path}
                isNew={person.isNew}
                isSoon={person.isSoon}
                address={person.address}
                content={person.content}
                isOffice={true}
                $isPremium={person.content === 'premium'}
              />
            ))}
        </TilesPersonSection>
        <GradientOverlay />
      </TilesContainer>
    </SectionWrapper>
  </Wrapper>
);

export default HomeWrapper;

// Styled‑components
const Wrapper = styled.div`
  margin-top: calc(104px);
  padding: 32px;
  width: calc(100% - 70px);
  box-sizing: border-box;
  min-height: 100vh;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    margin-top: 20px;
    width: 100%;
    padding: 24px 16px;
  }
`;

const SectionWrapper = styled.div`
  margin: 40px 0;

  &:first-child {
    margin-top: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin: 32px 0;
  }
`;

const TilesContainer = styled.div`
  position: relative;
`;

const GradientOverlay = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 100%;
  z-index: 2;
  pointer-events: none;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 30px;
  }
`;